import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-noi-popup',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './noi-popup.component.html',
  styleUrl: './noi-popup.component.scss'
})
export class NoiPopupComponent {
  @Input() roiPopupVisible = false;
  @Output() closeROIPopupEvent = new EventEmitter<void>();
  @Output() openDemoPopupEvent = new EventEmitter<void>();
  clientCount=100;
  pmePercentage=50;
  pmeCount= 0;
  missionCount= '0';
  roiMin= 0;
  roiMax= 0;
  currentStep= 1;
  commission= 1;
  openROIPopup() {
    this.roiPopupVisible = true;
  }
  closeROIPopup() {
    this.currentStep = 1;
    this.closeROIPopupEvent.emit();
  }
  calculateROI() {   
    const clientCount = this.clientCount || 0;
    const pmePercentage = this.pmePercentage || 0;
    
    if (clientCount === 0) {
        alert('Veuillez entrer un nombre de clients valide');
        return;
    }    
    // Calculate number of PME clients
    const pmeClients = Math.round(clientCount * (pmePercentage / 100));
    
    // Estimate missions (assume 30-50% conversion rate)
    const minConversion = 0.30;
    const maxConversion = 0.50;
    const minMissions = Math.round(pmeClients * minConversion);
    const maxMissions = Math.round(pmeClients * maxConversion);
    
    // Calculate revenue range
    const minRevenue = minMissions * 2000;
    const maxRevenue = maxMissions * 8000;
    this.pmeCount = pmeClients;
    this.missionCount = `${minMissions} - ${maxMissions}`;
    this.roiMin = minRevenue;
    this.roiMax = maxRevenue;
    this.currentStep = 2;    
 
  }
  openDemoPopup() {
    this.openDemoPopupEvent.emit();
  }
  resetROICalculator() {
    this.currentStep = 1;
  } 

}
